import _ from 'lodash';
import { connect } from 'react-redux';

import App from 'app/homepage/components/App';
import HomepageActions from 'app/homepage/HomepageActions';
import { withPublicSearchableServicesData } from 'app/service/components/WithPublicSearchableServicesData';
import {
  selectDefaultHomepageServices,
  selectHomepageMatchedServices,
  selectServiceSearchQuery,
  selectServiceSearchSelected,
} from 'app/homepage/Selectors';

const mapStateToProps = (state, props) => {
  const { loading } = props.data;
  const serviceSearchQuery = selectServiceSearchQuery(state);
  const serviceSearchSelected = selectServiceSearchSelected(state);

  return {
    isLoading: loading,
    defaultServices: selectDefaultHomepageServices(state, props),
    matchedServices: _.isEmpty(serviceSearchQuery)
      ? []
      : selectHomepageMatchedServices(state, props),
    errors: state.errors,
    categories: state.service.categories,
    serviceSearch: {
      query: serviceSearchQuery,
      selectedService: serviceSearchSelected,
    },
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // App Search
    updateAppSearchQuery(query) {
      dispatch(HomepageActions.updateAppSearchQuery(query));
    },
    changeAppSearchService(service) {
      dispatch(HomepageActions.changeAppSearchService(service));
    },
  };
};

export default _.flowRight(
  withPublicSearchableServicesData,
  connect(mapStateToProps, mapDispatchToProps)
)(App);
